import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NbEvaIconsModule } from '@nebular/eva-icons';

import {
  NbActionsModule,
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbContextMenuModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbMenuModule,
  NbPopoverModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbThemeModule,
  NbToastrModule,
  NbTooltipModule,
  NbUserModule,
  NbSelectModule
} from '@nebular/theme';

import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';

import {
  CardPaginationComponent,
  ConfirmDialogComponent,
  EqualHeightComponent,
  ErrorMessageComponent,
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
  ValidationMessageComponent
} from './components';

import { 
  CollapseDirective, 
  FixedSpinnerDirective, 
  ResizedDirective 
} from './directives';

import {
  AnyPipe,
  EmptyPipe, 
  NumberWithCommasPipe,
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe
} from './pipes';

import {
  OneColumnLayoutComponent,
  TwoColumnsLayoutComponent,
  ThreeColumnsLayoutComponent,
  CardLayoutComponent
} from './layouts';

import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';

const BASE_MODULES = [CommonModule, ReactiveFormsModule, TranslateModule];

const NB_MODULES = [
  NbSelectModule,
  NbLayoutModule,
  NbMenuModule,
  NbActionsModule,
  NbContextMenuModule,
  NbUserModule,
  NbSidebarModule,
  NbButtonModule,
  NgSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbInputModule,
  NbTooltipModule,
  NbToastrModule,
  NbButtonModule,
  AgGridModule,
  NbCardModule,
  NbPopoverModule,
  NbSpinnerModule,
  NbAlertModule
];
const COMPONENTS = [
  HeaderComponent,
  OneColumnLayoutComponent,
  CardLayoutComponent,
  EqualHeightComponent,
  ErrorMessageComponent,
  CardPaginationComponent,
  ConfirmDialogComponent,
  ValidationMessageComponent,
  SearchInputComponent,
  TwoColumnsLayoutComponent,
  ThreeColumnsLayoutComponent,
  FooterComponent
];

const PIPES = [AnyPipe, CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe, EmptyPipe];
const DIRECTIVES = [CollapseDirective, FixedSpinnerDirective, ResizedDirective];


@NgModule({
    imports: [...NB_MODULES, ...BASE_MODULES],
    exports: [...PIPES, ...COMPONENTS, ...NB_MODULES, ...BASE_MODULES, ...DIRECTIVES],
    declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES]
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME ],
        ).providers,
      ],
    };
  }
}
